<div class="overlay" (click)="close()"></div>
<aside class="mini-cart-panel">
  <!-- Header -->
  <header
    class="flex justify-between items-center p-4 border-b border-white/10"
  >
    <h2 class="text-lg font-semibold text-white">Mi Carrito</h2>
    <button (click)="close()" class="text-gray-400 hover:text-white transition">
      <svg
        class="w-6 h-6"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M6 18L18 6M6 6l12 12"
        />
      </svg>
    </button>
  </header>

  <!-- Items List -->
  <div class="p-4 flex-grow overflow-y-auto relative">
    @if (isLoading) {
      <div
        class="absolute inset-0 flex items-center justify-center bg-black/30"
      >
        <div
          class="animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-cyan-400"
        ></div>
      </div>
    }
    @if (!isLoading && enrichedCartItems.length > 0) {
      <div class="space-y-4">
        @for (item of enrichedCartItems; track item) {
          <div class="flex items-center gap-4">
            <img
              [src]="item.imageUrl"
              alt="{{ item.name }}"
              class="w-16 h-16 rounded-md object-cover border border-white/10"
            />
            <div class="flex-grow">
              <p class="font-semibold text-white">{{ item.name }}</p>
              <p class="text-sm text-gray-400">Cantidad: {{ item.quantity }}</p>
            </div>
            <p class="font-semibold text-white">
              {{ item.price * item.quantity | currency }}
            </p>
          </div>
        }
      </div>
    } @else {
      @if (!isLoading) {
        <p class="text-center text-gray-400 py-10">Tu carrito está vacío.</p>
      }
    }
  </div>

  <!-- Footer -->
  <footer class="p-4 border-t border-white/10 space-y-4">
    <div class="flex justify-between items-center font-semibold text-lg">
      <span class="text-gray-300">Subtotal:</span>
      <span class="text-white">{{ subtotal | currency }}</span>
    </div>
    <div class="grid grid-cols-2 gap-4">
      <a
        routerLink="/cart/sumary"
        (click)="close()"
        appGalaxyButton
        galaxyVariant="secondary"
        class="w-full text-center"
        >Ver Carrito</a
      >
      <a
        routerLink="/cart/sumary"
        (click)="close()"
        appGalaxyButton
        galaxyVariant="primary"
        class="w-full text-center"
        >Finalizar Compra</a
      >
    </div>
  </footer>
</aside>
